export default Object.freeze({
  1: 'This is a required field',
  2: 'Please enter a valid email address or phone number',
  3: 'An error occourd, please try again',
  4: 'Please enter a valid email address',
  5: 'Invalid invoice prefix',
  6: 'Invalid invoice number',
  7: 'You must enter either an invoice number or property address',
  8: 'Please enter a valid amount',
});
